"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var resource_1 = require("../shared/resource");
var lodash_1 = require("lodash");
var TruckType = /** @class */ (function (_super) {
    __extends(TruckType, _super);
    function TruckType() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TruckType.prototype.url = function (action) {
        return '/trucktypes/' + this.id + '/' + action;
    };
    TruckType.prototype.filterOptions = function (options) {
        options = lodash_1.clone(options);
        return options;
    };
    return TruckType;
}(resource_1.Resource));
exports.TruckType = TruckType;
